import { render, staticRenderFns } from "./_Basic.vue?vue&type=template&id=3c6643b4&scoped=true&"
import script from "./_Basic.vue?vue&type=script&lang=js&"
export * from "./_Basic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c6643b4",
  null
  
)

export default component.exports